exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".contactEdit{color:red}.signature-image{margin-top:9px;margin-bottom:9px;border:1px solid #ccc;height:125px;width:350px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/components/contact/contactEdit/contactEdit.styl
// module id = 1266
// module chunks = 0